module.exports = __webpack_public_path__ + "img/chart2.1d4580ee.svg";